import dash_api from '../../main/support/dash_api';

import { ReduxAsyncAction } from '../support/utils';

const GetOnboardingLink = new ReduxAsyncAction('GET_OB_LINK');
GetOnboardingLink.registerRequest(function () {
  return dash_api.get(`/v1/link/onboarding`).then((res) => {
    return { link: res.data };
  });
});
export const GET_OB_LINK = GetOnboardingLink.constants;
export const getOnboardingLink = GetOnboardingLink.request;
